import { Breadcrumb, Card, Tooltip } from "client/CommonComponents";
import './Admin.scss'

const AdminTab = ({
    acquisitionListingLinkClick,adminListing}:any) => {
    return(
        <div className='CustomerMyOrder mt-1'>
        {
            <Card data-attribute="Admin_Default_Card">
                <div className='create-new-order-container admin-tab'>
                    <div className='grid-block pt-3 pb-0'>
                        <div className='mb-3 top-section clearfix'>
                            <p className='pull-left blueLabel mt-2'>ADMIN SETTINGS</p>                                               
                        </div>
                        <div className='bottom-section'>
                            {
                                adminListing?.map((item:any)=>{
                                    return(
                                        <div className="admin-card" key={item.id}>
                                            <div className="card-header">
                                                <p className="blueLabel">{item.type}</p>
                                            </div>
                                            <div className="card-content">
                                                <ul>
                                                {
                                                    item.typeListing.map((itemVal:any)=>{
                                                        return(
                                                            <li key={itemVal.id}>
                                                                <Tooltip content={itemVal.link} data-attribute="Admin_Default_Tooltip">
                                                                    {/* <a href='/' onClick={(e?: any) => {acquisitionListingLinkClick(e,itemVal.link)}}>{itemVal.link}</a> */}
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn-link"
                                                                        onClick={(e?: any) => {acquisitionListingLinkClick(e,itemVal.link)}}
                                                                        disabled={!itemVal.isAllowed}
                                                                     data-attribute={`Admin_Default_Button_${itemVal.id}`}>
                                                                        {itemVal.link}
                                                                    </button>
                                                                </Tooltip>                                               
                                                            </li>
                                                        )
                                                    })
                                                }
                                                </ul>
                                            </div>
                                        </div>
                                    )
                                })
                            }                          
                        </div>
                    </div>
                </div>
            </Card>
        }      
        </div>
    )
}

export default AdminTab